import React from 'react';
import Hero from '../components/Hero';
import ClientMarquee from '../components/ClientMarquee';
import PortfolioGrid from '../components/PortfolioGrid';
import WhyYellow from '../components/WhyYellow';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import CTASection from '../components/CTASection';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import useSEO from '../hooks/useSEO';
import { ABOUT_YELLOW } from '../mock';

const Home = () => {
  useSEO({
    title: 'Yellow, Marketing Agency Liverpool | Video, Strategy & Design',
    description: 'Yellow is a Liverpool marketing agency helping businesses stop losing clients, staff and margin. Strategy, video, design and social delivered across the UK.',
    path: '/'
  });
  return (
    <>
      <Hero />
      <ClientMarquee />

      <section className="py-24 lg:py-28 bg-[#08080a]">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
            <div className="max-w-3xl">
              <p className="section-label mb-4">Recent work</p>
              <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.05]">
                Proving your <span className="text-[#F5CD1B]">credibility</span> to the world.
              </h2>
            </div>
            <Link to="/portfolio" className="btn-ghost inline-flex items-center gap-2 px-5 py-3 rounded-md uppercase text-sm self-start md:self-auto">
              View all <ArrowRight size={16} />
            </Link>
          </div>
          <PortfolioGrid limit={9} />
        </div>
      </section>

      <WhyYellow />
      <Testimonials />
      <FAQ />
      <section data-testid="about-yellow-section" className="py-20 border-t border-white/10">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-8">
          <h2 className="lg:col-span-4 font-display text-3xl md:text-4xl font-bold text-white">About <span className="text-[#F5CD1B]">Yellow</span></h2>
          <p data-testid="about-yellow-text" className="lg:col-span-8 text-white/70 text-base md:text-lg leading-relaxed">{ABOUT_YELLOW}</p>
        </div>
      </section>
      <CTASection />
    </>
  );
};

export default Home;
